import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from '@/App';
import Home from '@/screens/Home/Home';
import MobileOnly from '@/screens/MobileOnly/MobileOnly';
import Investors from '@/screens/Investors/Investors';
import ForLandlords from '@/screens/ForLandlords/ForLandlords';
import Privacy from '@/screens/Privacy/Privacy';
import Terms from '@/screens/Terms/Terms';
import AmbassadorRules from '@/screens/AmbassadorRules/AmbassadorRules';

/** Full-page jump to static arcade HTML (outside SPA shell). */
function GameRedirect() {
  useEffect(() => {
    window.location.replace('/game/index.html');
  }, []);
  return null;
}

const router = createBrowserRouter([
  {
    path: 'game',
    element: <GameRedirect />,
  },
  {
    path: 'game/',
    element: <GameRedirect />,
  },
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'playgrounds',
        element: <MobileOnly />,
      },
      {
        path: 'playgrounds/:id',
        element: <MobileOnly />,
      },
      {
        path: 'meetings',
        element: <MobileOnly />,
      },
      {
        path: 'meetings/:id',
        element: <MobileOnly />,
      },
      {
        path: 'create-meeting',
        element: <MobileOnly />,
      },
      {
        path: 'profile',
        element: <MobileOnly />,
      },
      {
        path: 'login',
        element: <MobileOnly />,
      },
      {
        path: 'registration',
        element: <MobileOnly />,
      },
      {
        path: 'for-landlords',
        element: <ForLandlords />,
      },
      {
        path: 'investors',
        element: <Investors />,
      },
      {
        path: 'privacy',
        element: <Privacy />,
      },
      {
        path: 'terms',
        element: <Terms />,
      },
      {
        path: 'ambassador-rules',
        element: <AmbassadorRules />,
      },
    ],
  },
]);

export default function Router() {
  return <RouterProvider router={router} />;
}
